import TextArea from '@/molecules/TextArea.vue';
import defaultValidators from '@/helpers/default-validators';
import { withGlobalFlow } from '@/parcours/flowGlobalSteps';
import SpecialistSelector from '@/parcours/components/specialistSelector.vue';
import { usePreventionParcours } from '@/parcours/composables/usePreventionParcours';
import BilanTms from '@/parcours/flows/tms/bilanTmsComponent.vue';
import BodyPartDetailTms from '@/parcours/flows/tms/bodyPartDetailTms.vue';
import SyndromeQuestionTms from '@/parcours/flows/tms/syndromeQuestionTms.vue';
import SymptomsDisplay from '@/parcours/flows/shared/SymptomsDisplay.vue';
import { tmsQuestionsConfig } from '@/parcours/flows/tms/tmsBodyParts.config';

const { update, getById } = usePreventionParcours('/cms/coordinator-patient-tms-infos');

export const tmsFlow = withGlobalFlow({
  id: 'tmsFlow',

  basePath: '/tmsFlow/flow',

  exitRoute: '/tmsFlow',

  async onInit({ route }) {
    const id = route.params.reservationId;
    const data = await getById(id);
    return { ...data };
  },

  steps: {
    tms: {
      type: 'component',
      component: BilanTms,
      title: 'Bilan des risques TMS',
    },
    bodyPart_cou: {
      type: 'component',
      header: 'internal',
      component: BodyPartDetailTms,
      props: () => ({ bodyPart: 'cou' }),
    },
    bodyPart_dos: {
      type: 'component',
      header: 'internal',
      component: BodyPartDetailTms,
      props: () => ({ bodyPart: 'dos' }),
    },
    bodyPart_epaule: {
      type: 'component',
      header: 'internal',
      component: BodyPartDetailTms,
      props: () => ({ bodyPart: 'epaule' }),
    },
    bodyPart_coude: {
      type: 'component',
      header: 'internal',
      component: BodyPartDetailTms,
      props: () => ({ bodyPart: 'coude' }),
    },
    bodyPart_poignet: {
      type: 'component',
      header: 'internal',
      component: BodyPartDetailTms,
      props: () => ({ bodyPart: 'poignet' }),
    },
    bodyPart_autre: {
      type: 'component',
      header: 'internal',
      component: BodyPartDetailTms,
      props: () => ({ bodyPart: 'autre' }),
    },
    questionsDetail: {
      type: 'component',
      title: 'Questions',
      isButtonNextDisabled: true,
      component: SymptomsDisplay,
      props: (data: any) => ({ data, config: tmsQuestionsConfig }),
    },
    syndromeQuestion: {
      type: 'component',
      header: 'internal',
      isButtonNextDisabled: true,
      component: SyndromeQuestionTms,
    },
    recommandation: {
      id: 'recommendation_health_professional',
      type: 'component',
      title: 'Recommandations',
      description:
        "Je recommande au patient d'aller consulter le(s) professionnel(s) de santé suivant(s):",
      component: SpecialistSelector,
      buttonNextTitle: 'Valider',
      props: {
        specialists: [
          { name: 'Médecin du travail', value: 'Médecin du travail' },
          { name: 'Médecin généraliste', value: 'Médecin généraliste' },
          { name: 'Masseur-Kinésithérapeute', value: 'Masseur-Kinésithérapeute' },
          { name: 'Ostéopathe', value: 'Ostéopathe' },
          { name: 'Rhumatologue', value: 'Rhumatologue' },
          { name: 'Autre', value: 'Autre' },
          { name: 'Aucun', value: 'Aucun' },
        ],
      },
    },
    lastComment: {
      type: 'form',
      title: 'Un dernier commentaire ?',
      description: 'Autre commentaire ou recommandation pour le patient',
      schema: {
        validateOnChange: false,
        validateOnBlur: true,
        fields: [
          {
            id: 'other_recommendation_idel',
            type: 'textarea',
            placeholder: 'Votre commentaire ...',
            as: TextArea,
            rules: defaultValidators.textOpt,
          },
        ],
      },
    },
  },

  transitions: {
    tms: { next: 'bodyPart_epaule' },
    bodyPart_epaule: { next: 'bodyPart_poignet', back: 'tms' },
    bodyPart_poignet: { next: 'bodyPart_cou', back: 'bodyPart_epaule' },
    bodyPart_cou: { next: 'bodyPart_dos', back: 'bodyPart_poignet' },
    bodyPart_dos: { next: 'bodyPart_coude', back: 'bodyPart_cou' },
    bodyPart_coude: { next: 'bodyPart_autre', back: 'bodyPart_dos' },
    bodyPart_autre: { next: 'recommandation', back: 'bodyPart_coude' },
    recommandation: { next: 'lastComment' },
    lastComment: { submit: true },
  },

  async onSubmit(data) {
    await update(data?.id, data);
  },
});
